import { RETRY_COUNT } from "@impero-com/common/utils/query_client";

import { useGetExtensions } from "api/generated/constants/constants";

export const useFileExtensionWhitelistQuery = () =>
    useGetExtensions({
        query: {
            select: (response) => response.data,
            retry: RETRY_COUNT,
        },
    });
